import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Table} from 'semantic-ui-react';
import {getNumericValue} from '../../../../../common/util/fieldsValidation';
import {getMonthName} from '../../../../../common/util/date';

class PartWatchingByMonthsList extends Component {
  sumOnOrdersWithOnHand() {
    const {data} = this.props;
    if (!data || !data.onOrders || !data.onOrders.length || !data.onHand || !data.onHand.length) {
      return [];
    }
    const onOrders = data.onOrders;
    const onHand = data.onHand;
    const result = [];

    onOrders.forEach((element, index) => {
      result.push({
        'year': element.year, 'month': element.month, 'quantity': element.quantity + onHand[index].quantity,
      });
    });
    
    return result;
  }

  renderTitleByColumn() {
    const {data} = this.props;

    return data.sales.map((element, index) => {
      return <Table.HeaderCell key={index} textAlign='center'>{getMonthName(element.month)}</Table.HeaderCell>;
    });
  }

  renderRowInfo(title, values) {
    return (
      <Table.Row>
        <Table.Cell textAlign='center'>{title}</Table.Cell>
        {this.renderValues(values)}
      </Table.Row>
    );
  }

  renderValues(values) {
    return values.map((element, index) => {
      return <Table.Cell key={index} textAlign='center'>{getNumericValue(element.quantity, 2)}</Table.Cell>;
    });
  }

  render() {
    const {loading, data} = this.props;
    if (loading || !data || !data.sales || !data.sales.length) {
      return null;
    }

    return (
      <Card fluid raised>
        <div className='data-by-months'>
          <Table striped>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell textAlign='center' />
                {this.renderTitleByColumn()}
              </Table.Row>
            </Table.Header>
        
            <Table.Body>
              {this.renderRowInfo('Ventas', data.sales)}
              {this.renderRowInfo('Recibido', data.receptions)}
              {this.renderRowInfo('O/H', data.onHand)}
              {this.renderRowInfo('O/O', data.onOrders)}
              {this.renderRowInfo('O/O + O/H', this.sumOnOrdersWithOnHand())}
              {this.renderRowInfo('B/O', data.backOrders)}
            </Table.Body>
          </Table>
        </div>
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.partWatching.loading,
    'data': state.partWatching.partWatching,
  };
};

export default connect(mapStateToProps, {
})(PartWatchingByMonthsList);
